import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoiceFormDepositLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormDepositLine'
import { InvoiceFormLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormLine'
import { isInvoiceFormRowLine } from '@features/invoices/utils/isInvoiceFormRowLine'

// A saved deposit line loses its deposit marker - it comes back as a plain "row" line.
// This re-tags it as a deposit line using the amount type already saved on the draft,
// without touching the amounts, which are already correct.
export const getDepositLinesFromPersistedRowLines = (
  lines: InvoiceFormLine[],
  depositValueType: InvoiceFormDepositLine['depositValueType'],
): InvoiceFormLine[] =>
  lines.map((line): InvoiceFormLine => {
    if (!isInvoiceFormRowLine(line)) {
      return line
    }

    const depositLine: InvoiceFormDepositLine = {
      depositValue: line.totalExcludingVat,
      depositValueType,
      description: line.productName,
      totalExcludingVat: line.totalExcludingVat,
      totalIncludingVat: line.totalIncludingVat,
      type: InvoiceLineType.Deposit,
      vatRateId: line.vatRateId,
      vatRatePercent: line.vatRatePercent,
    }

    return depositLine
  })
